import {Outlet} from 'react-router-dom';

const ContactsPageLayout = () => {
    return <><Outlet/></>;
};

export default ContactsPageLayout;
